// Enum of all cloning config option identifiers.
// These values are the canonical keys used on both the frontend (Redux state,
// BASE_CONFIGS_OPTIONS) and sent to the backend as copy_options strings.
// Translation strings live in config/locales/clone_leagues_sessions/en.yml
// under the path clone_leagues_sessions.leagues_configs.options.<id>.
const CloningConfigOptions = Object.freeze({
  COPY_PLAYER_ROSTER:           'copy_player_roster',
  TOURNAMENT_LIBRARY:           'tournament_library',
  COPY_LOGOS:                   'copy_logos',
  COPY_DFT:                     'copy_dft',
  COPY_ALL_PORTAL_PAGES:        'copy_all_portal_pages',
  ROUNDS_AND_SERIES:            'rounds_and_series',
  OPEN_REGISTRATION:            'open_registration',
  STRIPE_ACCOUNT:               'stripe_account',
  TOURNAMENTS:                  'tournaments',
  REGISTRATION_PAYMENT_OPTIONS: 'registration_payment_options',
  COPY_MANAGERS:                'copy_managers',
  GOLF_HUB_PAGE:                'golf_hub_page',
})

export default CloningConfigOptions
